module.exports = __webpack_public_path__ + "media/images/how_it_works/selection-ca3a29bd49763d54f5c12663a7baaca6.svg";